<template>
  <popup-container>
    <template slot="header">
      {{ $l['accountTypeSelect'] }}
    </template>

    <div class="popup-option"
      v-for="(option, index) in options"
      :key="index"
      @click="select(option)">
      {{ option.get(locale) }}
    </div>
  </popup-container>
</template>

<script>
import PopupContainer from '@/components/Popup/Container'
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    PopupContainer
  },

  computed: {
    options: function () {
      return this.$store.getters['option/accountTypes']
    }
  },

  methods: {
    select: function (option) {
      this.$store.commit('bank/setAccountType', option)
      this.$store.dispatch('bank/saveAccountType', option)
      this.$store.dispatch('popup/hide', null)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
